import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { loginMutation, registerMutation } from '../../queries/queries';
import { Field, Button } from '../../common/index';
import { Link } from 'react-router-dom';
import { useNavigationContext } from '../../context/NavigationContext';
import AuthHeader from './AuthHeader';

interface SaEnkeltAuthLoginFormProps {
  updateAuthTokenCallback: (token: string) => void;
  order?: boolean;
  registerForm?: boolean;
  accountActivated?: boolean;
  passwordReset?: boolean;
}

function SaEnkeltAuthLoginForm(props: SaEnkeltAuthLoginFormProps) {
  const { updateAuthTokenCallback, accountActivated, passwordReset, order } = props;
  const [user, setUser] = useState({ email: '', password: '', firstname: '', lastname: '', emailVerified: '' });
  const [registerForm, setRegisterForm] = useState(props.registerForm);
  const [errorNonMatchingEmail, setErrorNonMatchingEmail] = useState(false);
  const [register, { loading: registerLoading, error: registerError }] = useMutation(registerMutation);//, options);
  const [login, { loading: loginLoading, error: loginError }] = useMutation(loginMutation);//, options);

  const { setNavigationActivated } = useNavigationContext();
  useEffect(() => {
    setNavigationActivated(true);
  }, []);

  useEffect(() => {
    if (order) {
      setRegisterForm(true);
    }
  }, []);

  function submitForm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (loginLoading || registerLoading) {
      return null;
    }

    const vars = {
      variables: {
        email: user.email,
        password: user.password,
        firstname: user.firstname,
        lastname: user.lastname,
        longExpiry: false,
      },
    };

    setErrorNonMatchingEmail(false);
    if (registerForm) {
      if (user.email !== user.emailVerified) {
        setErrorNonMatchingEmail(true);
        return null;
      }
      register(vars)
        .then(result => { updateAuthTokenCallback(result && result.data.createUser); })
        .catch(useMutationError => { console.log('regErr', useMutationError, useMutationError && useMutationError.graphQLErrors) });
    } else {
      login(vars)
        .then(result => { updateAuthTokenCallback(result && result.data.login); })
        .catch(useMutationError => { console.log('loginErr', useMutationError, useMutationError && useMutationError.graphQLErrors) });
    }
  }

  const ss = (v: any) => setUser({ ...user, ...v });

  return (
    <>
      <div id="sa-enkelt-login">
        <AuthHeader />
        <div className="left">
          <div className="box md m-0">
            <h3>{registerForm ? 'Registrera konto' : 'Logga in på Mina sidor'}</h3>
            <form id="sa-enkelt-form" onSubmit={(e) => { submitForm(e); }}>

              {accountActivated && <p>Kontot är aktiverat. Vänligen logga in.</p>}
              {passwordReset && <p>Lösenordet är nu ändrat. Vänligen logga in.</p>}
              {(order && registerForm) && <p className="text">Fyll i dina uppgifter. När du sedan genomför köpet finns alla dina rabatter i appen när du loggat in med dina uppgifter.</p>}
              {(order && !registerForm) && <p className="text">Logga in. När du sedan genomför köpet finns alla dina rabatter i appen när du loggat in med dina uppgifter.</p>}

              <div className='row'>
                <Field type="email" x2 name="email" title="E-post" value={user.email} onChange={ss} />
              </div>

              <div className='row'>
                <Field type="password" x2 name="password" title="Lösenord" value={user.password} onChange={ss} />
              </div>

              {registerError && registerError.graphQLErrors.map(({ message }, i) => (
                <p className="error" key={i}>{message}</p>
              ))}
              {loginError && loginError.graphQLErrors.map(({ message }, i) => (
                <p className="error" key={i}>{message}</p>
              ))}
              {errorNonMatchingEmail && <p className="error">E-postadresserna matchar inte.</p>}

              <Button className="primary lg" loading={registerLoading || loginLoading} type="submit">{registerForm ? 'Registrera' : 'Logga in'}</Button>
              {!registerForm && <Link className="text new-pass" to="/forgotpassword">Glömt lösenord?</Link>}

              {registerForm && <Button className="md secondary" onClick={() => setRegisterForm(false)}>Logga in</Button>}
            </form>
          </div>
        </div>
        <div className="right" />
      </div>

    </>
  );
}

export default SaEnkeltAuthLoginForm;
